// Core
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// Chakra imports
import { Box, SimpleGrid, Image, Flex, Link, List, ListItem, Heading, Text, useColorModeValue } from '@chakra-ui/react';

// Assets
import logo from 'assets/img/logo.png';
const EXTERNAL_URL = "https://lmctplus.com";

export default function Footer(props) {
  const borderColor = useColorModeValue('#CBE7FF', '#262D47');
  const textColor = useColorModeValue('blue.800', '#9FABCB');
  const mbListPage = '23px';

  return (
    <Flex
      flexDirection={{
        base: 'column',
        md: 'row',
      }}
      alignItems={{
        base: 'center',
        md: 'start',
      }}
      justifyContent="space-between"
      px={{base: '15px', lg: '32px'}}
      pb="20px"
      borderTopWidth="0.05em"
      borderColor={borderColor}
      pt="32px"
      pb="32px"
    >
    	<SimpleGrid columns={{ base: 1, sm: 2, md: 5 }} rowGap="40px" maxW="1128px" w="100%" m="0 auto">
		  <Box>
	    	<Box mb='16px'>
	          <NavLink to="/">
	            <Image src={logo} alt='lmctplus logo' maxWidth="148px"/>
	          </NavLink>
	        </Box>
	        <Text variant="text-xs" color={textColor}>Copyright {new Date().getFullYear()}. LMCT PLUS</Text>
	      </Box>

	      <Box 
	      	display={{base: 'block', md: 'none'}} 
	      	w="100%" 
	      	textAlign={{base: 'left', sm: 'right'}}>
	        <Text variant="title" mb='14px' fontSize={'14px'}>ABN</Text>
	        <Text variant="text-sm" color={textColor}>93 627 297 474<br />
	          HQ- level 10, 440<br />
			  Collins Street,<br />
	          Melbourne 3000</Text>
	      </Box>

		  <Box ml={{md: '20px'}} mr={{md: '-20px'}}> 
		    <List>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <Link href={`${EXTERNAL_URL}/giveaways`} fontSize="14px" _hover={{textDecoration: 'none', color: '#0497FD'}}>Giveaways</Link>
		            </Text>
		        </ListItem>
		    </List>
		  </Box>

		  <Box> 
		    <List>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <Link href={`${EXTERNAL_URL}/become-a-partner`} fontSize="14px" _hover={{textDecoration: 'none', color: '#0497FD'}}>Become a Partner</Link>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <Link href={`${EXTERNAL_URL}/about`} fontSize="14px" _hover={{textDecoration: 'none', color: '#0497FD'}}>About</Link>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }}>
		            <Text variant="link-sm">
		                <Link href={`${EXTERNAL_URL}/faqs`} fontSize="14px" _hover={{textDecoration: 'none', color: '#0497FD'}}>FAQ</Link>
		            </Text>
		        </ListItem>
		    </List>
		  </Box>

		  <Box> 
		    <List>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <Link href={`${EXTERNAL_URL}/contact-support`} fontSize="14px" _hover={{textDecoration: 'none', color: '#0497FD'}}>Contact Support</Link>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }} mb={mbListPage}>
		            <Text variant="link-sm">
		                <Link href={`${EXTERNAL_URL}/terms-and-conditions`} fontSize="14px" _hover={{textDecoration: 'none', color: '#0497FD'}}>Terms & Conditions</Link>
		            </Text>
		        </ListItem>
		        <ListItem me={{ base: '20px', md: '44px' }}>
		            <Text variant="link-sm">
		                <Link href={`${EXTERNAL_URL}/privacy-policy`} fontSize="14px" _hover={{textDecoration: 'none', color: '#0497FD'}}>Privacy Policy</Link>
		            </Text>
		        </ListItem>
		    </List>
		  </Box>

	      <Box display={{base: 'none', md: 'block'}} w="100%" textAlign="right">
	        <Text variant="title" mb='14px' fontSize={'14px'}>ABN</Text>
	        <Text variant="text-sm" color={textColor}>93 627 297 474<br />
	          HQ- level 10, 440<br />
			  Collins Street,<br />
	          Melbourne 3000</Text>
	      </Box>
    	</SimpleGrid>
    </Flex>
  );
}
